import { Component, inject, OnInit } from '@angular/core';
import { AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { ProductUnitOfMeasure } from 'app/core/model/product-unit-of-measure';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-product-uom-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ isNew ? 'Enter New' : 'Edit' }} Product Unit Of Measure</h4>
        </div>
        <div class="modal-body" (keyup.esc)="cancel()">
            <dx-form [formData]="uom">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item dataField="abbreviation"></dxi-item>
                <dxi-item [label]="{ text: 'Type' }">
                    <div *dxTemplate>
                        <dx-radio-group [dataSource]="units" [(value)]="unit"></dx-radio-group>
                    </div>
                </dxi-item>
                @if (unit === 'Weight') {
                <dxi-item dataField="poundsMultiplier" editorType="dxNumberBox"></dxi-item>
                }
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success" (click)="save()">Save</button>
            <button class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: [``],
})
export class ProductUomDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);

    result = new Subject<{ success: boolean; value?: ProductUnitOfMeasure }>();
    uom: ProductUnitOfMeasure;
    isNew: boolean;
    units = ['Weight', 'Volume', 'Quantity'];
    unit: string;

    ngOnInit() {
        if (!this.uom) {
            this.isNew = true;
            this.uom = this.uow.productUnitsOfMeasure.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }
        if (this.uom.weightBasedUnit) this.unit = 'Weight';
        if (this.uom.volumeBasedUnit) this.unit = 'Volume';
        if (this.uom.quantityBasedUnit) this.unit = 'Quantity';
    }

    save() {
        this.uom.weightBasedUnit = this.unit === 'Weight';
        this.uom.volumeBasedUnit = this.unit === 'Volume';
        this.uom.quantityBasedUnit = this.unit === 'Quantity';
        if (this.unit !== 'Weight') this.uom.poundsMultiplier = null;
        this.result.next({ success: true, value: this.uom });
    }

    cancel() {
        this.result.next({ success: false });
    }
}
